import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'intervision_cart';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  function addItem(catalogItem, quantity) {
    setItems((prev) => {
      const existing = prev.find((i) => i.itemId === catalogItem.itemId);
      if (existing) {
        return prev.map((i) =>
          i.itemId === catalogItem.itemId ? { ...i, quantity: i.quantity + quantity } : i
        );
      }
      return [...prev, { ...catalogItem, quantity }];
    });
  }

  function removeItem(itemId) {
    setItems((prev) => prev.filter((i) => i.itemId !== itemId));
  }

  function updateQuantity(itemId, quantity) {
    setItems((prev) =>
      prev.map((i) => (i.itemId === itemId ? { ...i, quantity } : i))
    );
  }

  function replaceItem(oldItemId, newCatalogItem) {
    setItems((prev) => {
      const existing = prev.find((i) => i.itemId === oldItemId);
      const quantity = existing ? existing.quantity : 1;
      return prev
        .filter((i) => i.itemId !== oldItemId)
        .concat({ ...newCatalogItem, quantity });
    });
  }

  function clearCart() {
    setItems([]);
  }

  const itemCount = items.reduce((sum, i) => sum + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, itemCount, addItem, removeItem, updateQuantity, replaceItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
